import { render, staticRenderFns } from "./User-register.vue?vue&type=template&id=948a37d4&scoped=true"
import script from "./User-register.vue?vue&type=script&lang=js"
export * from "./User-register.vue?vue&type=script&lang=js"
import style0 from "./User-register.vue?vue&type=style&index=0&id=948a37d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "948a37d4",
  null
  
)

export default component.exports